import { Input, Tag } from 'antd';
import styled from 'styled-components';

export const StyledInputTag = styled(Input)`
  width: 100px;
  display: inline-block;
`;

export const StyledTag = styled(Tag)`
  padding: 2px 14px;
  margin: 4px;
`;
